
import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { MatDialog } from '@angular/material'

import { ChangePinComponent } from '../../dialogs/change-pin/change-pin.component'
import { ChangeStatusComponent } from '../../dialogs/change-status/change-status.component'

import { AuthService } from '../../../framework/auth/auth.service'
import { ActionItem, User } from '../../../framework/auth/interfaces'

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  actions: ActionItem[] = []
  user: User
  data = { role: '', level: '', provider: '' }

  constructor (
    public dialog: MatDialog,
    private router: Router,
    private auth: AuthService,
  ) {
    router.routeReuseStrategy.shouldReuseRoute = () => false
  }

  ngOnInit () {
    this.auth.authenticate()
    .subscribe(user => {
      this.user = user.currentUser
      if (user.currentCredential) {
        const validActions = []
        for(let action of user.currentCredential.landing){
          let actionsIn = []
          for(let i=0; i < Object.keys(action).length ;i++){
            //Add permission verification for this user
            if(!action[i].permissionCode || user.permissions[action[i].permissionCode]){
                let valid = true;
                if(user.currentCredential['switches']){
                    // console.log('actions', action[i]);
                    let act = action[i].action.split(':');
                    for(var key in user.currentCredential['switches']){
                        // console.log('key',key.toLowerCase());
                        // console.log('user',user.currentCredential['switches'][key]); //alerts key's value
                        let pp = act.find(x=> x === key.toLowerCase() );
                        if(pp){
                            valid = user.currentCredential['switches'][key];
                            break;
                        }
                    }
                }
              if(valid){
                  actionsIn.push(action[i])
              }
            }
          }
          if(actionsIn.length > 0){
            validActions.push(actionsIn)
          }
        }
        this.actions = [].concat.apply([], validActions)
      }
    })
  }

  run (commands) {
    return (
      {
        changePin: () => this.dialog.open(ChangePinComponent, { width: '60vw' }),
        changeStatus: () => this.dialog.open(ChangeStatusComponent, { width: '100vw' }),
      }[commands[0]] || (() => {})
    ).apply(this, commands.slice(1))
  }

  runAction (action: string) {
    const parsed = action.replace(/\$([a-z\d_]+)/gi, (_, key) => String(this.data[key]) )
    const [valid, command, params] = /^([^:]+):(.+)$/i.exec(parsed) || [null, null, null]
    if (valid) {
      (
        {
          run: this.run,
          url: url => this.router.navigate(url),
        }
      )[command].call(this, params.split(':'))
    }
  }

}
